module.exports = __webpack_public_path__ + "img/trainingsschema-week-1-6.5e4cfb37.png";